import { forwardRef } from 'react';

import { SvgStyled } from '@sternum/web/icons/icons.styles';
import { IconProps } from '@sternum/web/icons/icons.types';

export const QueryWidgetIcon = forwardRef<SVGSVGElement, IconProps>(function QueryWidgetIcon(
  { height = 32, width = 32, hasCursorPointer = false, ...props },
  ref,
) {
  return (
    <SvgStyled
      ref={ref}
      width={width}
      height={height}
      viewBox="0 0 32 32"
      data-has-cursor-pointer={hasCursorPointer}
      {...props}
    >
      <path
        d="M1 8.23529H31V26.5882C31 27.3679 30.3895 28 29.6364 28H2.36364C1.61052 28 1 27.3679 1 26.5882V8.23529Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M31 8.23529H29.6364V26.5882H2.36364V8.23529H1V26.5882C1 27.3679 1.61052 28 2.36364 28H29.6364C30.3895 28 31 27.3679 31 26.5882V8.23529Z"
        fill="#5137A1"
      />
      <path
        d="M1 5.41176C1 4.63207 1.61052 4 2.36364 4H29.6364C30.3895 4 31 4.63207 31 5.41176V8.23529H1V5.41176Z"
        fill="#5137A1"
      />
      <path
        d="M3.72727 6.11765C3.72727 6.5075 3.42201 6.82353 3.04545 6.82353C2.6689 6.82353 2.36364 6.5075 2.36364 6.11765C2.36364 5.7278 2.6689 5.41176 3.04545 5.41176C3.42201 5.41176 3.72727 5.7278 3.72727 6.11765Z"
        fill="#E8E1FC"
      />
      <path
        d="M6.45455 6.11765C6.45455 6.5075 6.14928 6.82353 5.77273 6.82353C5.39617 6.82353 5.09091 6.5075 5.09091 6.11765C5.09091 5.7278 5.39617 5.41176 5.77273 5.41176C6.14928 5.41176 6.45455 5.7278 6.45455 6.11765Z"
        fill="#CFC5F0"
      />
      <path
        d="M9.18182 6.11765C9.18182 6.5075 8.87656 6.82353 8.5 6.82353C8.12344 6.82353 7.81818 6.5075 7.81818 6.11765C7.81818 5.7278 8.12344 5.41176 8.5 5.41176C8.87656 5.41176 9.18182 5.7278 9.18182 6.11765Z"
        fill="#E8E1FC"
      />
      <path
        d="M8.35884 15.9559L10.1766 13.9085H6.74086V11.9026H13.1196V13.2744L10.8691 15.5905C11.5926 15.6135 12.2007 15.9053 12.6934 16.466C13.1862 17.0221 13.4325 17.7091 13.4325 18.5271C13.4325 19.5198 13.1018 20.3355 12.4404 20.9743C11.7835 21.6085 10.9423 21.9256 9.9169 21.9256C9.02024 21.9256 8.24787 21.6613 7.59979 21.1328C6.9517 20.5997 6.56996 19.915 6.45455 19.0786L8.27894 18.4444C8.3544 18.8672 8.54528 19.2165 8.85156 19.4922C9.15785 19.7633 9.51296 19.8989 9.9169 19.8989C10.3386 19.8989 10.6848 19.7656 10.9556 19.4991C11.2264 19.2325 11.3618 18.8902 11.3618 18.472C11.3618 18.0538 11.2175 17.7206 10.929 17.4724C10.6404 17.2243 10.2898 17.1002 9.87695 17.1002C9.59286 17.1002 9.30211 17.1714 9.00471 17.3139L8.35884 15.9559Z"
        fill="#EF145D"
      />
      <path
        d="M15.6165 21.9256C15.2702 21.9256 14.9751 21.8038 14.7309 21.5602C14.4912 21.312 14.3714 21.011 14.3714 20.6572C14.3714 20.3079 14.4912 20.0115 14.7309 19.7679C14.9751 19.5244 15.2702 19.4026 15.6165 19.4026C15.9672 19.4026 16.2623 19.5244 16.502 19.7679C16.7462 20.0069 16.8683 20.3033 16.8683 20.6572C16.8683 21.011 16.7462 21.312 16.502 21.5602C16.2623 21.8038 15.9672 21.9256 15.6165 21.9256Z"
        fill="#EF145D"
      />
      <path
        d="M18.1666 21.7877V20.2918L21.2362 17.1829C21.7955 16.6222 22.1461 16.2523 22.2882 16.0731C22.5678 15.6916 22.7121 15.3194 22.721 14.9563C22.721 14.6255 22.6011 14.3497 22.3614 14.1291C22.1217 13.9085 21.8199 13.7983 21.4559 13.7983C20.9854 13.7983 20.6214 13.9545 20.3639 14.267C20.1064 14.5749 19.9844 15.0069 19.9977 15.563L18.0202 15.4596C18.0024 14.761 18.1467 14.1291 18.4529 13.5639C18.7637 12.994 19.1831 12.5528 19.7114 12.2403C20.2441 11.9233 20.83 11.7647 21.4692 11.7647C22.4236 11.7647 23.2159 12.0611 23.8462 12.654C24.4766 13.2468 24.7917 13.9959 24.7917 14.9012C24.7917 15.5308 24.6142 16.1213 24.2591 16.6728C23.9084 17.2197 23.3779 17.8332 22.6677 18.5133L21.4692 19.7541H24.825V21.7877H18.1666Z"
        fill="#EF145D"
      />
    </SvgStyled>
  );
});
